import Dashboard from 'app/features/dashboard';
import React from 'react';
import { Navigate, Route } from 'react-router-dom';

export default function HomeRoute() {
  return (
    <>
      <Route path="" element={<Navigate to="home" />} />

      <Route path="home" element={<Dashboard />} />
    </>
  );
}
